<template>
  <el-container v-loading="isLoading" class="Edit">
    <el-header class="Edit-header">
      <el-page-header @back="close" :content="title"></el-page-header>
    </el-header>
    <el-main class="Edit-main">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="角色名称" prop="roleName" style="width: 500px">
          <el-input v-model="form.roleName"></el-input>
        </el-form-item>
        <el-form-item required label="权限设置" :error="powerListTip">
          <el-tree :data="powerValueList" show-checkbox node-key="id" ref="tree" :props="defaultProps" @check-change="setPowerListTip"></el-tree>
        </el-form-item>
        <el-form-item label="备注" prop="remark" style="width: 500px">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">提交</el-button>
          <el-button v-if="!isModify" @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Edit',
  data () {
    let _this = this
    let roleNameRule = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入角色名称'))
      } else {
        if (value.length < 1 || value.length > 100) {
          callback(new Error('长度在 1 到 100 个字符'))
        } else {
          if (!this.isModify || this.oldName !== value) {
            _this.$axios({
              method: 'post',
              headers: {
                'Authorization': this.$store.state.user.token,
                'ModuleId': this.thisModule.id
              },
              url: this.myOption.requestUrl + this.thisModule.exists,
              data: _this.qs.stringify({
                roleName: value
              })
            }).then((res) => {
              let code = res.data.code
              if (code === 200) {
                if (res.data.data.exists) {
                  callback(new Error('角色名称已存在'))
                } else {
                  callback()
                }
              } else {
                _this.myOption.abnormalCode(_this, code)
              }
            }).catch((err) => {
              _this.myOption.abnormalCode(_this, err)
            })
          } else {
            callback()
          }
        }
      }
    }
    return {
      id: '',
      title: '',
      oldName: '',
      role: [],
      thisModule: {},
      isModify: this.$store.getters.isEditId,
      isLoading: false,
      powerListTip: '',
      powerValueList: [],
      form: {
        roleName: '',
        remark: ''
      },
      rules: {
        roleName: [
          { required: true, validator: roleNameRule, trigger: 'blur' }
        ]
      },
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  created () {
    let powerModule = this.myOption.requestModule
    let powerData = []
    for (let a in powerModule) {
      let aVal = powerModule[a]
      let aObj = {id: aVal.power ? `${aVal.id}-${aVal.power}` : a, label: aVal.name}
      if (aVal.children) {
        aObj.children = []
        for (let b in aVal.children) {
          let bVal = aVal.children[b]
          let bObj = {id: bVal.power ? aVal.id ? `${aVal.id}-${bVal.power}` : `${bVal.id}-${bVal.power}` : `${bVal.id}`, label: bVal.name}
          if (bVal.children) {
            bObj.children = []
            for (let c in bVal.children) {
              let cVal = bVal.children[c]
              bObj.children.push({id: cVal.power ? `${bVal.id}-${cVal.power}` : `${cVal.id}`, label: cVal.name})
            }
          }
          aObj.children.push(bObj)
        }
      }
      powerData.push(aObj)
    }
    this.powerValueList = powerData
    let thisModule = powerModule.user.children.role.children
    if (this.isModify === 2) {
      this.isLoading = true
      this.id = this.$store.state.user.editId
      this.title = '修改角色'
      this.thisModule = thisModule.modify
      this.thisModule.detail = thisModule.detail
      this.getDetail()
    } else {
      this.title = '新建角色'
      this.thisModule = thisModule.add
    }
  },
  methods: {
    close () {
      this.myOption.switchListAndEdit(this, true)
    },
    setPowerListTip () {
      this.powerListTip = ''
    },
    // 获取详情信息
    getDetail () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.detail.id
        },
        url: this.myOption.requestUrl + this.thisModule.detail.api,
        data: this.qs.stringify({
          roleId: this.id
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          let data = res.data.data
          this.oldName = data.roleName
          this.form.roleName = data.roleName
          this.form.remark = data.remark
          let powerValueList = JSON.parse(data.powerValueList)
          let powerList = []
          for (let key in powerValueList) {
            let val = powerValueList[key]
            for (let i = 2; i < val.powerValue; i += i) {
              if ((val.powerValue & i) === i) {
                powerList.push(`${val.moduleId}-${i}`)
              }
            }
          }
          this.$refs.tree.setCheckedKeys(powerList)
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },

    // 提交表单
    submitForm (form) {
      let powerList = this.$refs.tree.getCheckedKeys()
      if (powerList.length === 0) {
        this.powerListTip = '请至少选择一项权限'
      }
      this.$refs[form].validate((valid) => {
        if (valid && this.powerListTip === '') {
          this.isLoading = true
          let powerValueList = {}
          for (let val of powerList) {
            if (val.indexOf('-') > -1) {
              let arr = val.split('-')
              let arr1 = parseInt(parseInt(arr[0]) / 10) * 10
              let arr2 = parseInt(arr[1])
              if (powerValueList[arr1]) {
                powerValueList[arr1].powerValue += arr2
              } else {
                powerValueList[arr1] = {}
                powerValueList[arr1].moduleId = arr1
                powerValueList[arr1].powerValue = arr2
              }
            }
          }
          let param = {
            roleName: this.form.roleName,
            powerValueList: JSON.stringify(powerValueList),
            remark: this.form.remark
          }
          if (this.isModify) {
            param.roleId = this.id
          }
          this.$axios({
            method: 'post',
            headers: {
              'Authorization': this.$store.state.user.token,
              'ModuleId': this.thisModule.id
            },
            url: this.myOption.requestUrl + this.thisModule.api,
            data: this.qs.stringify(param)
          }).then((res) => {
            let code = res.data.code
            this.isLoading = false
            if (code === 200) {
              this.$message.success(`${this.isModify ? '修改' : '新建'}角色成功`)
              this.$router.push({path: this.$route.path.replace('/edit', '/list')})
            } else {
              this.myOption.abnormalCode(this, code)
            }
          }).catch((err) => {
            this.isLoading = false
            this.myOption.abnormalCode(this, err)
          })
        } else {
          return false
        }
      })
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.$refs.tree.setCheckedKeys([])
      this.setPowerListTip()
    }
  },
  beforeDestroy () {
    this.$store.dispatch('SetEditId', false)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/role/Edit.vue